const SECOND_MS = 1000
const MINUTE_MS = 60 * SECOND_MS
const HOUR_MS = 60 * MINUTE_MS

export const QUEST_STREAM_QUERY_POLICY = {
    staleTime: 1 * MINUTE_MS,
    gcTime: 10 * MINUTE_MS,
    maxPages: 20,
} as const

// Ranked streams must not replace rows because a panel remounted, the tab
// regained focus, or the network reconnected. Realtime/background checks expose
// the shared new-items pill; only an explicit invalidation (pill/nav/PTR) may
// cross the freshness boundary.
export const RANKED_STREAM_QUERY_LIFECYCLE_POLICY = {
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
} as const

export const refetchStreamAfterExplicitInvalidation = (query: {
    state: { isInvalidated: boolean }
}) => query.state.isInvalidated

// The one reconnect exception: a stream whose first load failed has no rows to
// replace, so reconnecting retries it instead of leaving the panel blank.
export const refetchFailedStreamOnReconnect = (query: {
    state: { status: string; data: unknown }
}) => query.state.status === 'error' && query.state.data === undefined

export const QUEST_ENTITY_QUERY_POLICY = {
    staleTime: 5 * MINUTE_MS,
    // Feed pages store quest ids and hydrate from normalized entities at render time.
    // Do not GC these entries until retention is reference-aware.
    gcTime: Infinity,
    structuralSharing: false,
} as const

export const ANSWER_ENTITY_QUERY_POLICY = {
    staleTime: 15 * MINUTE_MS,
    // Answers are normalized behind quests, embeds, media viewers, and parent chains.
    // Do not GC these entries until retention is reference-aware.
    gcTime: Infinity,
    structuralSharing: false,
} as const

export const USER_ENTITY_QUERY_POLICY = {
    staleTime: 10 * MINUTE_MS,
    gcTime: 1 * HOUR_MS,
} as const

export const ACTION_HISTORY_QUERY_POLICY = {
    staleTime: 2 * MINUTE_MS,
    gcTime: 15 * MINUTE_MS,
} as const

export const STREAMS_QUERY_POLICY = {
    staleTime: 5 * MINUTE_MS,
    gcTime: 30 * MINUTE_MS,
} as const

// Matches the server-side memes-panel activity cache TTL: refetching sooner
// than 5 minutes mostly returns the same cached ranking.
export const MEMES_QUERY_POLICY = {
    staleTime: 5 * MINUTE_MS,
    gcTime: 30 * MINUTE_MS,
} as const
